
<v-card class="app-panel" elevation="8">
    <div class="panel-head">
        <v-icon small :color="iconColor" class="mr-2">{{ icon }}</v-icon>
        <div class="panel-title">{{ title }}</div>
        <v-btn v-if="collapsible" icon x-small @click="expanded = !expanded">
            <v-icon small>{{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
        </v-btn>
        <v-btn icon x-small class="ml-1" :disabled="closeDisabled" @click="$emit('close')">
            <v-icon small>mdi-close</v-icon>
        </v-btn>
    </div>

    <v-progress-linear
        v-if   = "progress !== null"
        :value = "progress"
        :color = "progressColor"
        height = "4"
    />

    <div v-if="expanded" class="panel-body">
        <slot></slot>
    </div>
</v-card>
